import React from 'react';
import './FireToggle.css';

/**
 * Small floating toggle for showing/hiding NASA FIRMS fire detections.
 * Designed to sit inside a map wrapper with position: relative.
 */
function FireToggle({ active, onChange }) {
  return (
    <button
      type="button"
      className="map-fire-toggle"
      aria-pressed={active}
      onClick={() => onChange(!active)}
      title={active ? 'Hide active fire detections' : 'Show active fire detections'}
    >
      🔥 Fires
    </button>
  );
}

export default FireToggle;
